import { render } from "./AIAssistantDialog.vue?vue&type=template&id=c4ee6962"
import script from "./AIAssistantDialog.vue?vue&type=script&lang=js"
export * from "./AIAssistantDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__